import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigateWithQuery } from './useNavigateWithQuery';

type GoBackParams = {
  fromPathQueryKey: string;
  fallbackPathDefault: string;
  excludeParams?: string[];
};

export const useGoBackByQuery = (): { goBack: (params: GoBackParams) => void } => {
  const location = useLocation();
  const navigate = useNavigateWithQuery();

  const goBack = useCallback(
    ({ fromPathQueryKey, fallbackPathDefault, excludeParams = [] }: GoBackParams) => {
      const searchParams = new URLSearchParams(location.search);
      const fromPath = searchParams.get(fromPathQueryKey);

      if (fromPath) {
        navigate(fromPath, { excludeParams: [fromPathQueryKey, ...excludeParams] });
      } else {
        // Fallback to default if no fromPathQueryKey parameter.
        // Still honor excludeParams so params like `defaultValues` aren't
        // preserved onto the fallback path (preserveQuery defaults to true).
        navigate(fallbackPathDefault, {
          excludeParams: [fromPathQueryKey, ...excludeParams],
        });
      }
    },
    [navigate, location.search],
  );

  return { goBack };
};
